export const SET_PRODUCT_ID = "SET_PRODUCT_ID";
export const FETCH_PRODUCT_ITEM_REQUEST = "FETCH_PRODUCT_ITEM_REQUEST";
export const FETCH_PRODUCT_ITEM_SUCCESS = "FETCH_PRODUCT_ITEM_SUCCESS";
export const FETCH_PRODUCT_ITEM_FAILURE = "FETCH_PRODUCT_ITEM_FAILURE";
export const INCREMENT_CART_ITEM = "INCREMENT_CART_ITEM";
export const DECREMENT_CART_ITEM = "DECREMENT_CART_ITEM";
export const CALC_TOTALPRICE = "CALC_TOTALPRICE";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const POST_CART_REQUEST = "POST_CART_REQUEST";
export const POST_CART_FAILURE = "POST_CART_FAILURE";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_ITEM_CART_REQUEST = "POST_ITEM_CART_REQUEST";
export const POST_ITEM_CART_FAILURE = "POST_ITEM_CART_FAILURE";
export const POST_ITEM_CART_SUCCESS = "POST_ITEM_CART_SUCCESS";
export const PAY_CART_REQUEST = "PAY_CART_REQUEST";
export const PAY_CART_FAILURE = "PAY_CART_FAILURE";
export const PAY_CART_SUCCESS = "PAY_CART_SUCCESS";
export const ACCEPT_PAID = "ACCEPT_PAID";
export const REMAIN_RESERV = "REMAIN_RESERV";
